<div class="login-container">
  <div class="welcome-text-container">
    <h1 class="welcome-text">Welcome Back!</h1>
  </div>

  <img src="assets/images/login-logo.png" alt="login-logo" class="login-logo" />

  <div class="login-card">
    <button nz-button nzType="primary" (click)="login()" class="login-button">Sign In with SSO</button>
    <p class="terms">
      By proceeding, you agree to our
      <a href="#">Terms of Service</a> and
      <a href="#">Privacy Policy</a>
    </p>
  </div>
  <img src="assets/images/login-c.png" alt="login-c" class="login-c" />
</div>
